import { Component, Inject, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CommentRendererComponent } from '../../grid-renderer/comment.grid-renderer';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-view-comments',
    templateUrl: './view-comments.component.html',
    styleUrls: ['./view-comments.component.scss'],
    standalone: false // NOSONAR
})
export class ViewCommentsComponent implements OnInit {
  heading: any;
  gridApi: any;
  defaultColDef: any;
  columnDef: any;
  icons: any;
  context: any;
  displayRowData: any;
  gridOptions: any;
  rowClassRules: any;

  constructor(public dialogRef: MatDialogRef<ViewCommentsComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any) {
    this.context = {
      componentParent: this
    };
    this.rowClassRules = {    
      'row-even': 'node.rowIndex % 2 == 0',                         // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',                                      // NOSONAR
    };
  }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.columnDef = [
      {
        headerName: "DOMICILE", autoHeight: true, field: "cpMatrix.logisticsPoint", minWidth: 120, maxWidth: 120,
        unSortIcon: true, sortable: true,floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
      },
      {
        headerName: "USER", autoHeight: true, field: "updatedBy", minWidth: 120, maxWidth: 150,
        unSortIcon: true, sortable: true,floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
      },
      {
        headerName: "COMMENTS", autoHeight: true, field: "comments",
        unSortIcon: true, sortable: true, wrapText: true,
        cellStyle: { cursor: 'pointer' },floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true, 
        cellRendererFramework: CommentRendererComponent
      },
      {
        headerName: "DATE", field: "updatedDate", minWidth: 120, maxWidth: 150,
        unSortIcon: true, sortable: true,floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        // valueFormatter: this.dateFormatter
      }
    ]
    this.displayRowData = this.dataStore.result.map((item: any) => {
      return {
        ...item,
        updatedDate: this.dateFormatter(item.updatedDate),
        
      };
    });
  
    this.gridOptions = {
      // getRowNodeId: function (data) {
      //   // return the row header value as the unique identifier for the row
      //   return data.rowHeader;
      // }
    };
    this.icons = {
      sortUnSort: '<img src="./assets/images/Icon awesome-sort.svg">',
    };
  }

  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }

  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.gridApi = params.api
  
    this.gridApi.sizeColumnsToFit();
  }

  dateFormatter(res)
  {
    return res ? moment.utc(res).format('MM/DD/YYYY HH:mm') : null;
  }

}
